import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

// Reads the OS motion preference and keeps tracking it, so a user who flips
// the setting mid-session gets the static experience without a reload.
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(
    () => window.matchMedia?.(QUERY).matches ?? false
  );

  useEffect(() => {
    const mq = window.matchMedia?.(QUERY);
    if (!mq) return;
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
